import { render, staticRenderFns } from "./module-a.vue?vue&type=template&id=2b0110ee&scoped=true&"
var script = {}
import style0 from "./module-a.vue?vue&type=style&index=0&id=2b0110ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0110ee",
  null
  
)

export default component.exports